import React from 'react'
import SvgHomeDesktopHeaderBG from '../../svgs/backgrounds/home/desktop_header_background'
import SvgHomeMobileHeaderBG from '../../svgs/backgrounds/home/mobile_header_background'
import SvgAuthenticationDesktopHeroBG from '../../svgs/backgrounds/authentication/desktop_hero_background'
import SvgEnterpriseConnectionsDesktopHeroBG from '../../svgs/backgrounds/enterprise_ready/desktop_hero_background'
import SvgAuthenticationMobileHeroBG from '../../svgs/backgrounds/authentication/mobile_hero_background'
import SvgUserAccountDesktopHeroBG from '../../svgs/backgrounds/user_account/desktop_hero_background'
import SvgUserAccountMobileHeroBG from '../../svgs/backgrounds/user_account/mobile_hero_background'
import { BottomHeroBackground, MiddleHeroBackground, TopHeroBackground } from './style'
import SvgBlogMobileHeroBG from '../../svgs/backgrounds/blog/mobile_hero_background'
import SvgBlogDesktopHeroBG from '../../svgs/backgrounds/blog/desktop_hero_background'
import SvgEnterpriseConnectionsMobileHeroBG from '../../svgs/backgrounds/enterprise_ready/mobile_hero_background'

export const HomeHeroBackground = () => {
  return (
    <TopHeroBackground>
      <SvgHomeMobileHeaderBG className="mobile-background" />
      <SvgHomeDesktopHeaderBG className="desktop-background" />
    </TopHeroBackground>
  )
}

export const UserAccountHeroBackground = () => {
  return (
    <BottomHeroBackground>
      <SvgUserAccountMobileHeroBG className="mobile-background" />
      <SvgUserAccountDesktopHeroBG className="desktop-background" />
    </BottomHeroBackground>
  )
}

export const AuthenticationHeroBackground = () => {
  return (
    <BottomHeroBackground>
      <SvgAuthenticationMobileHeroBG className="mobile-background" />
      <SvgAuthenticationDesktopHeroBG className="desktop-background" />
    </BottomHeroBackground>
  )
}

export const EnterpriseConnectionsHeroBackground = () => {
  return (
    <MiddleHeroBackground>
      <div className="enterprise-connections-background">
        <SvgEnterpriseConnectionsMobileHeroBG className="mobile-background" />
        <SvgEnterpriseConnectionsDesktopHeroBG className="desktop-background" />
      </div>
    </MiddleHeroBackground>
  )
}

export const BlogHeroBackground = () => {
  return (
    <MiddleHeroBackground>
      <SvgBlogMobileHeroBG className="mobile-background" />
      <SvgBlogDesktopHeroBG className="desktop-background" />
    </MiddleHeroBackground>
  )
}
